/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line




$('.gb-product-gallery__media-slider-main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    //fade: true,
     //  dots: true,
    infinite: true,
        speed: 500,
    //draggable: true,
    //pauseOnHover: true,
    //swipeToSlide: true,
   // adaptiveHeight: true,
   //fade: true,
   //speed: 10000,
    asNavFor: '.gb-product-single__thumbnails-main',
   prevArrow: '<button class="slick-prev slick-arrow gb-slick-prev" type="button" aria-label="Previous"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right-bold" viewBox="0 0 192 192"><path d="m72 36 60 60-60 60" stroke="currentColor" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
   nextArrow: '<button class="slick-next slick-arrow gb-slick-next" type="button" aria-label="Previous"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right-bold" viewBox="0 0 192 192"><path d="m72 36 60 60-60 60" stroke="currentColor" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
});
$('.gb-product-single__thumbnails-main').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    //vertical:true,
   //asNavFor: '.gb-product-gallery__media-slider-main',
   // dots: false,
    //focusOnSelect: true,
    arrows: false,
       dots: false,
       // infinite: true,
       // speed: 300,
    infinite: true,
//draggable: true,
//pauseOnHover: true,
//swipeToSlide: true,
    //verticalSwiping:true,
 /*  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
      }
    }
  ]*/
});



$(".swatch__button label.swatch__label").click(function(){
  
    var get_filter_value = $(this).attr("data-swatch").toLowerCase();
   /* $(".gb-product-gallery__media-slider-main .slick-slide").filter(function() {
      $(this).toggle($(this).text().toLowerCase().indexOf(get_filter_value) > -1);
    });
    $(".gb-product-single__thumbnails-main .slick-slide").filter(function() {
      $(this).toggle($(this).text().toLowerCase().indexOf(get_filter_value) > -1);
  });*/
  //$('.gb-product-gallery__media-slider-main').slick('unslick');
  //$('.gb-product-single__thumbnails-main').slick('unslick');
  
  $('.gb-product-gallery__media-slider-main').slick('slickUnfilter');
  $('.gb-product-single__thumbnails-main').slick('slickUnfilter');
  
  $('.gb-product-gallery__media-slider-main').slick('slickFilter', function() {
    return $(this).find('.product-gallery__media-slide').attr("data-swatch") == get_filter_value;
  });
  $('.gb-product-single__thumbnails-main').slick('slickFilter', function() {
    return $(this).find('.product-single__thumbnail').attr("data-swatch") == get_filter_value;
  });
  
  
})
/*$(".swatch__button label.swatch__label").click(function(){
    var get_filter_value = $(this).attr("data-swatch").toLowerCase();
    setTimeout(function () {
      $(".gb-product-gallery__media-slider-main .slick-slide").filter(function() {
         $(this).toggle($(this).text().toLowerCase().indexOf(get_filter_value) > -1);
      });
    }, 1000);     
})  */
setTimeout(function () { 
   $(".gb-product-single__thumbnails-main").css("opacity", "1");
  var get_filter_value1 = $(".swatch__button .swatch__input:checked~.swatch__label").trigger('click'); 
 // $('.gb-product-gallery__media-slider-main .slick-slide').slick('slickFilter','nougat');
 /* var get_filter_value1 = $(".swatch__button .swatch__input:checked~.swatch__label").attr('data-swatch');
 $('.gb-product-gallery__media-slider-main').slick('slickFilter', function() {
    return $(this).find('.product-gallery__media-slide').attr("data-swatch") == get_filter_value1;
  });*/
}, 1000);   
  
//$(".gb-product-single__thumbnails-main .slick-slide ").click(function(){  
 $('body').on('click', '.gb-product-single__thumbnails-main .slick-slide', function(){  
  //$(".gb-product-single__thumbnails-main .slick-slide").removeClass('slick-current');  
   get_slide = $(this).index();
  $('.gb-product-gallery__media-slider-main').slick('slickGoTo', +get_slide); 
  //$('.gb-product-gallery__media-slider-main').slickGoTo(slideIndex); 
 //setTimeout(function () {  $(this).addClass('gbslick-current');  }, 1000);
});  






  
  
})();
